import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';

import { useToast } from 'src/hooks/useToast';

import { genericApiToaster } from 'src/services/utils';

import TicketForm from 'src/sections/ticketCreation/TicketForm';

import { useAuth } from '../../hooks/useAuth';
import { fetchFormById } from '../../services/form.service';
import { fetchDepartments } from '../../services/department.service';

export default function CreateTicketPage() {
  const [departments, setDepartments] = useState();
  const [favoriteFormData, setFavoriteFormData] = useState();
  const { state } = useLocation();
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const { showToast, hideToast } = useToast();

  const fetchDerpartmentsData = async () => {
    genericApiToaster(
      fetchDepartments,
      [],
      '',
      t('errorMessages.couldntLoadDep'),
      showToast,
      hideToast,
      t,
      setDepartments
    );
  };

  const fetchFavoriteFormData = async (id) => {
    genericApiToaster(
      fetchFormById,
      id,
      '',
      t('errorMessages.errorLoadingFormData'),
      showToast,
      hideToast,
      t,
      setFavoriteFormData
    );
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchDerpartmentsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state?.formId) {
      fetchFavoriteFormData(state.formId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  return <TicketForm departments={departments} favoriteForm={favoriteFormData} />;
}
